"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreInternalTokens = exports.NovasolOwnerTokens = exports.NovasolTokens = exports.HoseasonsTokens = exports.FincallorcaTokens = exports.CottagesTokens = exports.AgnosticTokens = void 0;
const agnostic_1 = __importDefault(require("./web/agnostic"));
const cottages_1 = __importDefault(require("./web/cottages"));
const fincallorca_1 = __importDefault(require("./web/fincallorca"));
const hoseasons_1 = __importDefault(require("./web/hoseasons"));
const novasol_1 = __importDefault(require("./web/novasol"));
const novasol_owner_1 = __importDefault(require("./web/novasol-owner"));
const core_internal_1 = __importDefault(require("./web/core-internal"));
const font_overrides_1 = require("../font-overrides");
const replaceCustomFontNames = (tokens) => {
    // Convert tokens to a JSON string for manipulation
    let tokensFontRename = JSON.stringify(tokens);
    // Loop through the fontOverrides object and replace each key with its fontFamily
    tokensFontRename = Object.entries(font_overrides_1.fontOverrides).reduce((font, [originalFont, fontDetails]) => {
        const regex = new RegExp(originalFont, 'g'); // Create a dynamic regex for global replacement
        return font.replace(regex, fontDetails.fontFamily);
    }, tokensFontRename);
    // Convert the modified string back to JSON
    const tokensFontRenameJson = JSON.parse(tokensFontRename);
    return tokensFontRenameJson;
};
exports.AgnosticTokens = agnostic_1.default;
exports.CottagesTokens = cottages_1.default;
exports.FincallorcaTokens = fincallorca_1.default;
exports.HoseasonsTokens = replaceCustomFontNames(hoseasons_1.default);
exports.NovasolTokens = novasol_1.default;
exports.NovasolOwnerTokens = novasol_owner_1.default;
exports.CoreInternalTokens = core_internal_1.default;
//# sourceMappingURL=index.js.map